import { useCallback, useState } from "react";
import {
  readWorkspaceSidebarCollapsedPreference,
  writeWorkspaceSidebarCollapsedPreference,
} from "./workspace-sidebar-collapsed-preference.js";

export function useWorkspaceSidebarCollapsedPreference(
  storageKey: string,
): [boolean, (collapsed: boolean) => void] {
  const [collapsed, setCollapsedState] = useState(() =>
    readWorkspaceSidebarCollapsedPreference(storageKey),
  );

  const setCollapsed = useCallback(
    (next: boolean) => {
      setCollapsedState(next);
      writeWorkspaceSidebarCollapsedPreference(storageKey, next);
    },
    [storageKey],
  );

  return [collapsed, setCollapsed];
}
